<app-dashboard-subheader
  [(startDate)]="startDate"
  [(endDate)]="endDate"
  [(period)]="period"

  [(productCategoryIds)]="productCategoryIds"
  [(campaignIds)]="campaignIds"
  [(mediumIds)]="mediumIds"
  [(sourceIds)]="sourceIds"

  [productCategoryIdAllValue]="productCategoryIdAllValue"
  [campaignIdAllValue]="campaignIdAllValue"
  [mediumIdAllValue]="mediumIdAllValue"
  [sourceIdAllValue]="sourceIdAllValue"

  (startDateChange)="onStartDateChange($event)"
  (endDateChange)="onEndDateChange($event)"
  (productCategoryIdsChange)="onProductCategoryIdsChange($event)"
  (campaignIdsChange)="onCampaignIdsChange($event)"
  (sourceIdsChange)="onSourceIdsChange($event)"
  (mediumIdsChange)="onMediumIdsChange($event)"
/>

<div>
  <div class="details-content container-fluid h-100">
    <div class="row h-100">
      <div class="col-content d-flex flex-column h-100">
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                @if (
                  salesPerformanceData$ | async; as salesPerformanceData
                  ) {
                  <div
                    class="row mt-2"
                  >
                    <div class="col-12 col-md">
                      <app-generic-grid
                        style="height: 300px"
                        [data]="salesPerformanceData"
                        [tabViewName]="'salesPerformanceReport'"
                        [pageSize]="999"
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
